//
//
//
//
//
//

export default {
  data () {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false
    }
  },
  computed: {
    lang () {
      return this.$store.getters.getLanguage
    },

    login () {
      return this.$store.getters.getLogin
    }
  },
  watch: {
    lang () {
      document.title = this.$t('meta')
    }
  },
  components: {
  },
  methods: {
  },
  mounted () {
    // 移动端active效果
    document.body.addEventListener('touchstart', function () { })
    // 订阅语言切换事件
    window.subscribe.listen('languageChange', () => {
      document.title = this.$t('meta')
    })
  }
}
